export { default } from "./PrincipalSchoolProfile";
